import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../_common/_service/authservice.service';
import { Clipboard } from "@angular/cdk/clipboard"; // first import this in .ts
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-voucher',
  templateUrl: './Voucherresponse.component.html',
  styleUrls: ['./Voucherresponse.component.scss']

})
export class VoucherresponseComponent implements OnInit {

  invoiceno: any;
  userresponsestatus: any;
  Voucher: any;
  email: any;
  message: any;

  constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute, public clipboard: Clipboard,
    private toastr: ToastrService) { }

  ngOnInit(): void {

    this.getParamValueQueryString();

  }

  onCopy(value: any) {
    this.clipboard.copy(value);
    this.toastr.success('Voucher Code Copied');

  }

  getParamValueQueryString() {
    debugger
    const url = window.location.href;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      this.invoiceno = httpParams.get('invoiceno');
      this.email = httpParams.get('email');

    }

    if (this.invoiceno != null || this.invoiceno != undefined) {

      this.UPIresponseapi(this.invoiceno, this.email);//CAll API       

    }

  }

  UPIresponseapi(invoiceno: any, email: any) {
    debugger

    var xx = {
      "email": email,
      "invoiceno": invoiceno

    }

    this.authService.UPIresponseapi(xx).subscribe(response => {
      debugger

      if (response.apiData != null) {
        if (response.apiData.code != null) {
          this.userresponsestatus = true;
          this.Voucher = response.apiData.Code;
        }
        else {
          this.userresponsestatus = false;
        }
      }
      else {
        this.userresponsestatus = false;
        this.message = response.apiMessage;
        
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        //////console.log(err.error);
      } else {
        //////console.log(err.error);
      }
    });
  }



}
